/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_No_Events_To_MergeInputs */



/**
* | output |
* | --- |
* | "No events to merge" |
*
* @param {Event_Group_Options_No_Events_To_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_no_events_to_merge = /** @type {((inputs?: Event_Group_Options_No_Events_To_MergeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_No_Events_To_MergeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun événement à fusionner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ereignisse zum Zusammenführen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento da unire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет событий для объединения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay eventos para fusionar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有要合并的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("統合するイベントはありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विलय करने के लिए कोई इवेंट नहीं हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há eventos para mesclar.")
	return /** @type {LocalizedString} */ ("No events to merge")
});